import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'

const defaultState = {
  success: false,
  invalid: null
}

const SignInReducer = combineReducers({
  request: createRequestReducer('FORGOT_PASSWORD:SEND_EMAIL'),
  forgot: createReducer(defaultState, {
    'FORGOT_PASSWORD:SEND_EMAIL_REQUEST_ERROR': (state, { error }) => ({
      ...state,
      invalid: true
    }),
    'FORGOT_PASSWORD:SEND_EMAIL_REQUEST_SUCCESS': state => ({
      ...state,
      success: true
    }),
    'FORGOT_PASSWORD:REFRESH': state => ({ ...defaultState })
  })
})

export default SignInReducer
